import { Sparkles, Flame, Crown, Moon, Eye, Ear, HeartHandshake } from "lucide-react";

// Amethyst — set apart from the four palm-line colors.
const MARK_COLOR = "#6C3A7A";
const GIFT_ICON = { jupiter: Crown, saturn: Moon, apollo: Eye, mercury: Ear, healer: HeartHandshake };

// The "mark of the witch" (Mystic Cross) + mount crosses — parchment styled,
// reused on the reveal screen and inside the take-home keepsake.
export default function MysticMarkings({ markings }) {
  if (!markings || !markings.witch) return null;
  const { witch, gifts = [] } = markings;
  const WitchIcon = witch.present ? Sparkles : Flame;

  return (
    <>
      <h2 className="mb-1 mt-10 font-display text-3xl text-parch-ink">Mystic Markings</h2>
      <p className="mb-4 text-sm text-parch-inkSoft">
        The marks the old traditions read as signs of the sixth sense.
      </p>

      <div
        data-testid="mystic-witch-mark"
        className={`rounded-xl border border-parch-line p-5 ${witch.present ? "" : "bg-parch-card"}`}
        style={{
          borderLeftWidth: 5,
          borderLeftColor: MARK_COLOR,
          ...(witch.present ? { background: "rgba(108,58,122,0.10)" } : {}),
        }}
      >
        <div className="flex items-start gap-3">
          <span
            className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full"
            style={{ background: "rgba(108,58,122,0.15)", color: MARK_COLOR }}
          >
            <WitchIcon size={18} />
          </span>
          <div>
            <p className="font-display text-2xl" style={{ color: MARK_COLOR }}>{witch.title}</p>
            <p className="mt-0.5 font-mono text-[10px] uppercase tracking-wide text-parch-inkSoft">{witch.subtitle}</p>
          </div>
        </div>
        <p className="mt-3 leading-relaxed text-parch-ink">{witch.text}</p>
      </div>

      {gifts.length > 0 && (
        <div className="mt-3 space-y-3">
          {gifts.map((g) => {
            const Icon = GIFT_ICON[g.key] || Sparkles;
            return (
              <div
                key={g.key}
                data-testid={`mystic-gift-${g.key}`}
                className="rounded-xl border border-parch-line bg-parch-card p-5"
                style={{ borderLeftWidth: 5, borderLeftColor: MARK_COLOR }}
              >
                <div className="flex items-start gap-3">
                  <span
                    className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full"
                    style={{ background: "rgba(108,58,122,0.15)", color: MARK_COLOR }}
                  >
                    <Icon size={16} />
                  </span>
                  <div>
                    <p className="font-display text-xl" style={{ color: MARK_COLOR }}>{g.title}</p>
                    <p className="mt-0.5 font-mono text-[10px] uppercase tracking-wide text-parch-inkSoft">{g.subtitle}</p>
                  </div>
                </div>
                <p className="mt-2 leading-relaxed text-parch-ink">{g.text}</p>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
